import React from 'react'
import { useTranslation } from 'react-i18next'
import { Text } from 'react-native-paper'
import { commonColors } from '../../../../common-frontend/src/theme'
import { Link } from '../../ui/atoms/Link'
import { paths } from '../links'

export const AlreadyHaveAcc = ({
  navigation,
  testID = 'link',
  dontNavigate,
}) => {
  console.log('here dont', dontNavigate)
  const { t } = useTranslation('auth')
  return (
    <Text
      style={{
        fontSize: 16,
        fontWeight: '500',
        color: commonColors.textLight,
        marginTop: 20,
        alignSelf: 'center',
      }}
    >
      {t('signUp.existingQuestion')}
      <Link
        textStyle={{ fontSize: 16, fontWeight: '500' }}
        title={t('SignIn')}
        color={commonColors.accentText}
        onPress={() =>
          dontNavigate
            ? dontNavigate(true)
            : navigation.navigate(paths.Auth._self, {
                screen: paths.Auth.SignIn,
              })
        }
        testID={testID}
      />
    </Text>
  )
}
